// extracted by mini-css-extract-plugin
module.exports = {"root":"NotFoundPage_root__MKiN2","content":"NotFoundPage_content__31UxA","title":"NotFoundPage_title__33Ze_","footer":"NotFoundPage_footer__32QCE"};